import { render, staticRenderFns } from "./GoalRating.vue?vue&type=template&id=e38de1c0&scoped=true"
import script from "./GoalRating.vue?vue&type=script&lang=js"
export * from "./GoalRating.vue?vue&type=script&lang=js"
import style0 from "./GoalRating.vue?vue&type=style&index=0&id=e38de1c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38de1c0",
  null
  
)

export default component.exports